import { ButtonSize, Loader } from '@mobalytics/shared';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useLocation } from 'react-router';
import { AccountsButton } from '../../../ui/buttons/accounts-button/accounts-button.component';
import { MascotLayout } from '../../../ui/layout/mascot-layout/mascot-layout.component';
import { genPaymentV2ErrorPath, genRedirectUrl } from '../../../utils/formatter/path.formatter';
import { PaymentError } from '../payment-error.types';
import type { ProductI } from '../payment.types';
import { getThankYouButtonTitle } from './utils/get-thank-you-button-title';
import { getThankYouDescription } from './utils/get-thank-you-description';
import { getThankYouTitle } from './utils/get-thank-you-title';
import { useThankYou } from './thank-you.hook';

interface Props {
  className?: string;
  product: ProductI;
}

export const ThankYou: React.FC<Props> = (props) => {
  const { className, product } = props;

  const { state } = useThankYou(product);
  const { t } = useTranslation();
  const { search } = useLocation();

  const returnBackToApp = () => {
    window.location.href = genRedirectUrl();
  };

  if (state === 'loading') {
    return (
      <MascotLayout
        mascotEmotion={'calm'}
        title={t('Confirming payment...')}
        description={t(
          "Please wait for a moment while we're confirming your payment. This should take just a few moments."
        )}
        className={className}
      >
        <Loader />
      </MascotLayout>
    );
  }

  if (state === 'error') {
    return <Redirect to={genPaymentV2ErrorPath(product.id, product.price.id, search, PaymentError.INTERNAL_ERROR)} />;
  }

  return (
    <MascotLayout
      mascotEmotion={'happy'}
      title={getThankYouTitle(product.__typename, t)}
      description={getThankYouDescription(product.__typename, t)}
      className={className}
    >
      <AccountsButton analyticsButtonName="Start climbing" size={ButtonSize.H40} onClick={returnBackToApp}>
        {getThankYouButtonTitle(product.__typename, t)}
      </AccountsButton>
    </MascotLayout>
  );
};
